import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Typography } from "../../UI/Typography";
import { Controller, useForm } from "react-hook-form";


import { Modal } from "../Modal";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useSnackbar } from "../../hooks/useSnackbar";
import {
  IIntegrationsMappings,
} from "../../services/IntegrationApi";
import useAuth from "../../routes/login/AuthContext";
import { normalize } from "../../helpers/normalize";
import { Button } from "../../UI/MUIButton";
import {
  Lease, 
  AccDebug } from "../../services/IntegrationApi";
import { AccDebugTable } from "./AccDebugTable";

interface IFormData {
  firstName: string | null;
  lastName: string | null;
  leaseNumber: string | null;
}

interface IProps {
  defaultProps?: IIntegrationsMappings;
}

export const AccDebugModal: React.FC<IProps> = (props) => {
  const { control, handleSubmit, reset } = useForm<IFormData>();
  const [ leases, setLeases ] = React.useState<Array<Lease>>([]);
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { showErrorSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const { setIsOpen } = useModalContext();
  const { getAuthToken } = useAuth();

  React.useEffect(() => {
    if (!props.defaultProps) return;
    reset({
      firstName: null,
      lastName: null,
      leaseNumber: null
    });
  }, [normalize(props.defaultProps)]);

  const closeModal = () => setIsOpen(false);

  const submitHandler = async (data: IFormData) => {
    setIsLoading(true);

    try {
      const res = await AccDebug(selectedNetworkId, 
        data.firstName, 
        data.lastName,
        data.leaseNumber, 
        await getAuthToken());
        setIsLoading(false);
      const { leases, error } = res as any;
      if(error) {
        showErrorSnackbar(error.description);
      } else {
        setLeases(leases as Array<Lease>);
      }
    } catch (err) {
      showErrorSnackbar("An Error Occurred");
    }
    
    
  };


  return (
    <Modal
      maxWidth="md"
    >
      <Box p={3} width={700}>
        <Grid container mb={4}>
          <Grid item>
            <Typography variant="h4">Debug ACC Import</Typography>
          </Grid>
        </Grid>
        
        <Grid container spacing={2} pl={3} pr={3}>
          <Grid item xs={6}>
            <Controller
              control={control}
              name="firstName"
              render={({ field }) => <TextField disabled={isLoading} fullWidth variant="standard" label="First Name" {...field} />}
            />
          </Grid>
          <Grid item xs={6}>
            <Controller
              control={control}
              name="leaseNumber"
              render={({ field }) => (
                <TextField disabled={isLoading} fullWidth variant="standard" label="Lease Number" {...field} />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Controller
              control={control}
              name="lastName"
              render={({ field }) => <TextField disabled={isLoading} fullWidth variant="standard"  label="Last Name" {...field} />}
            />
          </Grid>
        </Grid>
        <Grid container mt={4} spacing={2} pl={3} pr={3} justifyContent="flex-end">
          <Grid item>
            <Button variant="outlined" onClick={closeModal}>
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button color="primary" loading={isLoading} variant="contained" onClick={handleSubmit(submitHandler)}>
              Search
            </Button>
          </Grid>
        </Grid>
      </Box>
      {
        leases.length > 0 &&
        <Box p={3} width={600}>
          <Grid container spacing={2} px={2}>
            <AccDebugTable data={leases} />
          </Grid>
        </Box>
      }
      
      
    </Modal>
  );
};
